export const SET_BACKTEST_PREVIEW = "SET_BACKTEST_PREVIEW";
export const CLEAR_PREVIEW = "CLEAR_PREVIEW";